export default __webpack_public_path__ + "static/media/GeorgeOlive.8a6cde6d.png";